/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { supabase } from './supabase'

const CATEGORIES = ['Family', 'Bills', 'Appointment', 'Birthday', 'Holiday', 'Other']
const CATEGORY_COLORS = {
  Family: '#3498db',
  Bills: '#e74c3c',
  Appointment: '#2ecc71',
  Birthday: '#e94560',
  Holiday: '#9b59b6',
  Other: '#95a5a6'
}
function getHolidaysForYear(year) {
  // Helper to get nth weekday of a month
  function nthWeekday(year, month, weekday, n) {
    let count = 0
    for (let d = 1; d <= 31; d++) {
      const date = new Date(year, month - 1, d)
      if (date.getMonth() !== month - 1) break
      if (date.getDay() === weekday) {
        count++
        if (count === n) return d
      }
    }
  }

  // Helper to get last weekday of a month
  function lastWeekday(year, month, weekday) {
    for (let d = 31; d >= 1; d--) {
      const date = new Date(year, month - 1, d)
      if (date.getMonth() !== month - 1) continue
      if (date.getDay() === weekday) return d
    }
  }

  // Easter calculation (Anonymous Gregorian algorithm)
  function getEaster(year) {
    const a = year % 19
    const b = Math.floor(year / 100)
    const c = year % 100
    const d = Math.floor(b / 4)
    const e = b % 4
    const f = Math.floor((b + 8) / 25)
    const g = Math.floor((b - f + 1) / 3)
    const h = (19 * a + b - d - g + 15) % 30
    const i = Math.floor(c / 4)
    const k = c % 4
    const l = (32 + 2 * e + 2 * i - h - k) % 7
    const m = Math.floor((a + 11 * h + 22 * l) / 451)
    const month = Math.floor((h + l - 7 * m + 114) / 31)
    const day = ((h + l - 7 * m + 114) % 31) + 1
    return { month, day }
  }

  const easter = getEaster(year)

  return [
    { title: "New Year's Day", month: 1, day: 1 },
    { title: "Valentine's Day", month: 2, day: 14 },
    { title: "St. Patrick's Day", month: 3, day: 17 },
    { title: "Easter", month: easter.month, day: easter.day },
    { title: "Mother's Day", month: 5, day: nthWeekday(year, 5, 0, 2) },
    { title: "Memorial Day", month: 5, day: lastWeekday(year, 5, 1) },
    { title: "Father's Day", month: 6, day: nthWeekday(year, 6, 0, 3) },
    { title: "Independence Day", month: 7, day: 4 },
    { title: "Labor Day", month: 9, day: nthWeekday(year, 9, 1, 1) },
    { title: "Halloween", month: 10, day: 31 },
    { title: "Thanksgiving", month: 11, day: nthWeekday(year, 11, 4, 4) },
    { title: "Christmas Eve", month: 12, day: 24 },
    { title: "Christmas", month: 12, day: 25 },
    { title: "New Year's Eve", month: 12, day: 31 },
  ]
}

function Calendar() {
  const [currentDate, setCurrentDate] = useState(new Date())
  const [events, setEvents] = useState([])
  const [showForm, setShowForm] = useState(false)
  const [selectedEvent, setSelectedEvent] = useState(null)
  const [form, setForm] = useState({ title: '', date: '', time: '', category: 'Family', notes: '' })
  const [editForm, setEditForm] = useState(null)
  const [userEmail, setUserEmail] = useState('')

useEffect(() => {
  async function getUser() {
    try {
      const cookie = document.cookie.split(';').find(c => c.trim().startsWith('CF_Authorization='))
      if (cookie) {
        const token = cookie.trim().replace('CF_Authorization=', '')
        const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
        if (payload.email) { setUserEmail(payload.email); return }
      }
    } catch {}
    const cached = localStorage.getItem('bf_user_email')
    setUserEmail(cached || '')
  }
  getUser()
}, [])
// eslint-disable-next-line react-hooks/exhaustive-deps
useEffect(() => {
  fetchEvents()
}, [currentDate])

  async function fetchEvents() {
    const year = currentDate.getFullYear()
    const month = String(currentDate.getMonth() + 1).padStart(2, '0')
    const start = `${year}-${month}-01`
    const lastDay = new Date(year, currentDate.getMonth() + 1, 0).getDate()
    const end = `${year}-${month}-${String(lastDay).padStart(2, '0')}`
    const { data, error } = await supabase
      .from('events')
      .select('*')
      .gte('date', start)
      .lte('date', end)
    if (!error) setEvents(data)
  }

  async function addEvent() {
    if (!form.title || !form.date) return
    const { error } = await supabase.from('events').insert([{ ...form, user_email: userEmail }])
    if (!error) {
      setForm({ title: '', date: '', time: '', category: 'Family', notes: '' })
      setShowForm(false)
      fetchEvents()
    }
  }

  async function updateEvent() {
    if (!editForm.title || !editForm.date) return
    const { error } = await supabase
      .from('events')
      .update({ title: editForm.title, date: editForm.date, time: editForm.time, category: editForm.category, notes: editForm.notes })
      .eq('id', editForm.id)
    if (!error) {
      setSelectedEvent(null)
      setEditForm(null)
      fetchEvents()
    }
  }

  async function deleteEvent(id) {
    await supabase.from('events').delete().eq('id', id)
    setSelectedEvent(null)
    setEditForm(null)
    fetchEvents()
  }

  function getDaysInMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
  }

  function getFirstDayOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1).getDay()
  }

  function getEventsForDay(day) {
  const year = currentDate.getFullYear()
  const month = String(currentDate.getMonth() + 1).padStart(2, '0')
  const dateStr = `${year}-${month}-${String(day).padStart(2, '0')}`
  const dbEvents = events.filter(e => e.date === dateStr)
  const yearHolidays = getHolidaysForYear(year)
  const holidays = yearHolidays
    .filter(h => h.month === currentDate.getMonth() + 1 && h.day === day)
    .map(h => ({ id: `holiday-${h.title}`, title: h.title, category: 'Holiday', isHoliday: true }))
  return [...holidays, ...dbEvents]
}

  function prevMonth() {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1))
  }

  function nextMonth() {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1))
  }

  function handleDayClick(day) {
    const year = currentDate.getFullYear()
    const month = String(currentDate.getMonth() + 1).padStart(2, '0')
    const dateStr = `${year}-${month}-${String(day).padStart(2, '0')}`
    setForm({ ...form, date: dateStr })
    setShowForm(true)
  }

  function handleEventClick(e, event) {
  e.stopPropagation()
  setSelectedEvent(event)
  setEditForm(null)
  setShowForm(false)
}

  const daysInMonth = getDaysInMonth(currentDate)
  const firstDay = getFirstDayOfMonth(currentDate)
  const monthName = currentDate.toLocaleString('default', { month: 'long', year: 'numeric' })

  return (
    <div className="calendar-container">
      <div className="calendar-header">
        <button onClick={prevMonth}>←</button>
        <h2>{monthName}</h2>
        <button onClick={nextMonth}>→</button>
        <button className="add-event-btn" onClick={() => { setShowForm(!showForm); setSelectedEvent(null) }}>+ Add Event</button>
      </div>

      {showForm && (
        <div className="event-form">
          <h3>New Event</h3>
          <div className="event-form-fields">
            <input placeholder="Title" value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} />
            <input type="date" value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} />
            <input type="time" value={form.time} onChange={e => setForm({ ...form, time: e.target.value })} />
            <select value={form.category} onChange={e => setForm({ ...form, category: e.target.value })}>
              {CATEGORIES.map(c => <option key={c}>{c}</option>)}
            </select>
            <input placeholder="Notes (optional)" value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} />
            <button onClick={addEvent}>Save Event</button>
            <button onClick={() => setShowForm(false)} className="cancel-btn">Cancel</button>
          </div>
        </div>
      )}

      {selectedEvent && !editForm && (
  <div className="event-form">
    <h3>{selectedEvent.title}</h3>
    <div className="event-details">
      <p><strong>Date:</strong> {selectedEvent.date}</p>
      {selectedEvent.time && <p><strong>Time:</strong> {selectedEvent.time}</p>}
      <p><strong>Category:</strong> {selectedEvent.category}</p>
      {selectedEvent.notes && <p><strong>Notes:</strong> {selectedEvent.notes}</p>}
    </div>
    <div className="event-form-fields" style={{ marginTop: '16px' }}>
      <button onClick={() => setEditForm({ ...selectedEvent })}>Edit</button>
      <button onClick={() => deleteEvent(selectedEvent.id)} className="cancel-btn" style={{ background: '#e74c3c' }}>Delete</button>
      <button onClick={() => setSelectedEvent(null)} className="cancel-btn">Close</button>
    </div>
  </div>
)}

{selectedEvent && editForm && (
  <div className="event-form">
    <h3>Edit Event</h3>
    <div className="event-form-fields">
      <input placeholder="Title" value={editForm.title} onChange={e => setEditForm({ ...editForm, title: e.target.value })} />
      <input type="date" value={editForm.date} onChange={e => setEditForm({ ...editForm, date: e.target.value })} />
      <input type="time" value={editForm.time} onChange={e => setEditForm({ ...editForm, time: e.target.value })} />
      <select value={editForm.category} onChange={e => setEditForm({ ...editForm, category: e.target.value })}>
        {CATEGORIES.map(c => <option key={c}>{c}</option>)}
      </select>
      <input placeholder="Notes (optional)" value={editForm.notes} onChange={e => setEditForm({ ...editForm, notes: e.target.value })} />
      <button onClick={updateEvent}>Update Event</button>
      <button onClick={() => deleteEvent(selectedEvent.id)} className="cancel-btn" style={{ background: '#e74c3c' }}>Delete</button>
      <button onClick={() => { setSelectedEvent(null); setEditForm(null) }} className="cancel-btn">Cancel</button>
    </div>
  </div>
)}

      <div className="calendar-grid">
        {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(d => (
          <div key={d} className="calendar-day-header">{d}</div>
        ))}
        {Array(firstDay).fill(null).map((_, i) => (
          <div key={`empty-${i}`} className="calendar-day empty" />
        ))}
        {Array(daysInMonth).fill(null).map((_, i) => {
          const day = i + 1
          const dayEvents = getEventsForDay(day)
          const isToday = new Date().toDateString() === new Date(currentDate.getFullYear(), currentDate.getMonth(), day).toDateString()
          return (
            <div key={day} className={`calendar-day ${isToday ? 'today' : ''}`} onClick={() => handleDayClick(day)}>
              <span className="day-number">{day}</span>
              {dayEvents.map(event => (
  <div key={event.id} className="event-pill" style={{ 
  background: CATEGORY_COLORS[event.category] || '#9b59b6',
  opacity: event.user_email && event.user_email !== userEmail && !event.isHoliday ? 0.6 : 1,
  border: event.user_email && event.user_email !== userEmail && !event.isHoliday ? '2px solid white' : 'none'
}} onClick={e => handleEventClick(e, event)}>
    <span>{event.title}</span>
    {!event.isHoliday && (
      <button onClick={e => { e.stopPropagation(); deleteEvent(event.id) }}>×</button>
    )}
  </div>
))}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Calendar